import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { paths } from '@AppRoutes/constants';
import { NavGroup } from '@els/els-react--nav-group';

function UnauthSiteNavigation({ userHasInstitutionLogin, userHasRegistration }) {
  const getLinks = () => {
    const links = [];

    links.push({
      id: 'unauth-sign-in',
      children: 'Sign in',
      href: paths.LOGIN,
      routerComponent: Link,
      routerHrefAttribute: 'to',
    });

    if (userHasInstitutionLogin) {
      links.push({
        id: 'unauth-institution-sign-in',
        children: 'Institution sign in',
        href: paths.LOGIN_INSTITUTION,
        routerComponent: Link,
        routerHrefAttribute: 'to',
      });
    }

    if (userHasRegistration) {
      links.push({
        id: 'unauth-register',
        children: 'Register',
        href: paths.PRIVATE_REGISTER,
        routerComponent: Link,
        routerHrefAttribute: 'to',
      });
    }

    return links;
  };

  return <NavGroup title="Main navigation" linkElementData={getLinks()} />;
}

UnauthSiteNavigation.propTypes = {
  userHasInstitutionLogin: PropTypes.bool,
  userHasRegistration: PropTypes.bool,
};

export default UnauthSiteNavigation;
